import React from 'react';
import ReactDOM from 'react-dom';

/* Import Components */
// import FeeCalculator from './components/FeeCalculator';
import CourseComparison from './components/CourseComparison';
// import DrupalProjectStats from './components/DrupalProjectStats';

// Define Main as a functional component
const Main = () => (
  <>
    {
      // <FeeCalculator />
    }
    {
      <CourseComparison />
    }
    {
      // <DrupalProjectStats projectName="drupal" />
    }
  </>
);


// # Example 1: Simple "Hello, World" code
ReactDOM.render(
  <Main />,
  document.getElementById('compare-app')
);
